import { render, staticRenderFns } from "./muestrasDetalle.vue?vue&type=template&id=27f52fcf&scoped=true&"
import script from "./muestrasDetalle.vue?vue&type=script&lang=js&"
export * from "./muestrasDetalle.vue?vue&type=script&lang=js&"
import style0 from "./muestrasDetalle.vue?vue&type=style&index=0&id=27f52fcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f52fcf",
  null
  
)

export default component.exports